import { EDGELESS_HANDLE_GEOMETRY } from '@blocksuite/affine-shared/consts';
import { unsafeCSSVarV2 } from '@blocksuite/affine-shared/theme';
import { css } from 'lit';

import { DRAG_HANDLE_CONTAINER_WIDTH } from './config.js';

export const styles = css`
  :host {
    pointer-events: none !important;
  }

  .affine-drag-handle-widget {
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    contain: size layout;
  }

  .affine-drag-handle-container {
    top: 0;
    left: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    width: ${DRAG_HANDLE_CONTAINER_WIDTH}px;
    min-height: 12px;
    pointer-events: auto;
    user-select: none;
    box-sizing: border-box;
  }
  .affine-drag-handle-container:hover {
    cursor: grab;
  }

  .affine-drag-handle-grabber {
    width: 4px;
    height: 100%;
    border-radius: 1px;
    background: var(--streamlain-v2-text-placeholder);
    transition: width 0.25s ease;
  }

  .affine-drag-handle-grabber.dots {
    width: 14px;
    height: 26px;
    box-sizing: border-box;
    padding: 5px 2px;
    border-radius: 4px;
    gap: 2px;
    display: flex;
    flex-wrap: wrap;
    background-color: transparent;
    transform: translateX(-100%);
    transition: unset;
  }

  .affine-drag-handle-grabber.dots:hover {
    background-color: ${unsafeCSSVarV2('layer/background/hoverOverlay')};
  }

  .affine-drag-handle-grabber.dots > .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    flex: 0 0 4px;
    background-color: ${unsafeCSSVarV2('icon/secondary')};
  }

  .affine-edgeless-drag-handle {
    position: absolute;
    z-index: 4;
    display: grid;
    grid-template-columns: repeat(3, 3px);
    grid-template-rows: 3px;
    gap: 4px;
    place-content: center;
    width: ${EDGELESS_HANDLE_GEOMETRY.width}px;
    height: ${EDGELESS_HANDLE_GEOMETRY.height}px;
    padding: 0;
    border: 1px solid ${unsafeCSSVarV2('layer/insideBorder/border')};
    border-radius: 12px;
    color: ${unsafeCSSVarV2('icon/secondary')};
    background: ${unsafeCSSVarV2('layer/background/primary')};
    box-shadow:
      inset 0 1px 0 rgb(255 255 255 / 10%),
      0 1px 1px rgb(0 0 0 / 20%),
      0 4px 12px rgb(0 0 0 / 18%);
    cursor: grab;
    font-size: 0;
    line-height: 0;
    pointer-events: none;
    opacity: 0;
    transform: translate(-50%, -100%)
      rotate(var(--edgeless-drag-handle-rotate, 0deg))
      translateY(-${EDGELESS_HANDLE_GEOMETRY.gap}px);
    scale: 0.88;
    transform-origin: center bottom;
    touch-action: none;
  }

  .affine-edgeless-drag-handle::after {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: ${EDGELESS_HANDLE_GEOMETRY.gap}px;
    content: '';
  }

  .affine-edgeless-drag-handle[data-visible='true'] {
    pointer-events: auto;
    opacity: 1;
    scale: 1;
  }

  .affine-edgeless-drag-handle[data-visible='true']:hover {
    border-color: ${unsafeCSSVarV2('icon/secondary')};
    box-shadow:
      inset 0 1px 0 rgb(255 255 255 / 14%),
      0 1px 2px rgb(0 0 0 / 24%),
      0 5px 14px rgb(0 0 0 / 22%);
  }

  .affine-edgeless-drag-handle:active {
    cursor: grabbing;
  }

  .affine-edgeless-drag-handle > .dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: currentColor;
    box-shadow: 0 1px 0 rgb(0 0 0 / 24%);
    pointer-events: none;
  }

  @media print {
    .affine-drag-handle-widget {
      display: none;
    }
  }
  .affine-drag-hover-rect {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px;
    background: var(--streamlain-v2-layer-background-hoverOverlay);
    pointer-events: none;
    z-index: 2;
    animation: expand 0.25s forwards;
  }
  @keyframes expand {
    0% {
      width: 0;
      height: 0;
    }
  }
`;
